import React, { useCallback, useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import { usePersistBoundStore } from '@/services/zustand/Store';
import * as Application from 'expo-application';

export default function Settings() {
  const offlineDurationStore = usePersistBoundStore(useCallback((state) => state.offlineDuration, []));
  const updateOfflineDuration = usePersistBoundStore(useCallback((state) => state.updateOfflineDuration, []));
  const favouriteEditionStore = usePersistBoundStore(useCallback((state) => state.favouriteEdition, []));
  const updateFavouriteEdition = usePersistBoundStore(useCallback((state) => state.updateFavouriteEdition, []));
  const [offlineDuration, setOfflineDuration] = useState(offlineDurationStore);
  const [favOutput, setFavOutput] = useState(favouriteEditionStore);
    
  return (
    <View style={styles.container}>
      <Text style={styles.label}>Offline Dauer:</Text> 
      <Picker
        selectedValue={offlineDuration}
        onValueChange={(itemValue) => {
          setOfflineDuration(itemValue);
          updateOfflineDuration(itemValue);
        }}
        style={styles.picker}
      >
        <Picker.Item label="1 Woche" value={1} />
        <Picker.Item label="2 Wochen" value={2} />
        <Picker.Item label="4 Wochen" value={4} />
        <Picker.Item label="dauerhaft" value={99} />
      </Picker>

      <Text style={styles.label}>Favorisierte Ausgabe:</Text>
      <Picker
        selectedValue={favOutput}
        onValueChange={(itemValue) => {
          setFavOutput(itemValue);
          updateFavouriteEdition(itemValue);
        }}
        style={styles.picker}
      >
        <Picker.Item label="DLZ" value="DLZ" />
        <Picker.Item label="MZ" value="MZ" />
        <Picker.Item label="BZ" value="BZ" />
        <Picker.Item label="DK" value="DK" />
      </Picker>

      <Text style={styles.labelversionInfo}>Version Info:</Text>
      <Text style={styles.versionInfo}>{Application.nativeApplicationVersion}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: '#000',
  },
  label: {
    color: '#fff',
    marginBottom: 18,
    marginTop: 18,
    fontSize: 16,
  },
  picker: {
    height: 50,
    width: '100%',
    color: '#fff',
    backgroundColor: '#888',
  },
  labelversionInfo: {
    color: '#fff',
    marginTop: 80,
    fontSize: 12,
  },
  versionInfo: {
    color: '#fff',
    marginBottom: 16,
    fontSize: 16,
  },
});
